import React from 'react';
import { Check, Circle } from 'lucide-react';
import { REGRAS_DE_SENHA } from '../utils/politicaDeSenha';

/**
 * Lista do que a senha ainda precisa atender, marcando cada item conforme a
 * pessoa digita. Anunciar as regras antes evita a sequencia de tentar, ser
 * recusado e adivinhar o que faltava.
 */
const RequisitosDeSenha: React.FC<{ senha: string }> = ({ senha }) => (
  <ul className="mt-3 space-y-1.5" aria-live="polite">
    {REGRAS_DE_SENHA.map((regra) => {
      const ok = regra.atende(senha);
      return (
        <li key={regra.chave} className={`flex items-center gap-2 text-sm ${ok ? 'text-green-700' : 'text-gray-500'}`}>
          {ok
            ? <Check className="h-4 w-4 shrink-0" />
            : <Circle className="h-3 w-3 shrink-0 ml-0.5 mr-0.5" />}
          <span>{regra.texto}</span>
          <span className="sr-only">{ok ? '(atendido)' : '(pendente)'}</span>
        </li>
      );
    })}
  </ul>
);

export default RequisitosDeSenha;
